<template>
  <div class="container">
    <div>
      <div class="tabs">
        <div v-if="isLoading == true">
          <cart-item-skeleton/>
        </div>
        <div class="container-seller" v-else>
          <div class="image-section">
            <img :src="shopData.shopLogo" class="image" :alt="shopData.shopName" />
          </div>
          <div class="seller-info">
            <div class="top-section-seller">
              <!-- <div class="star-section">
                <svg-icon
                  class="back-arrow"
                  :icon="back"
                  @click="this.$router.back()"
                ></svg-icon>
              </div> -->
              <div class="seller-name">{{ shopData.shopName }}</div>
            </div>
            <div class="bottom-section-seller">
              <div class="store-address">
                <svg-icon :icon="Intro" />
                <span>{{ shopData.intro }}</span>
              </div>
              <div class="store-domain">
                <svg-icon :icon="Notice" />
                <span>{{ shopData.shopNotice }}</span>
              </div>
              <!-- <div class="store-domain">
                <svg-icon :icon="CallIcon" />
                <span>0788700000</span>
              </div>
              <div class="store-domain">
                <svg-icon :icon="LinkIcon" />
                <span>icanlk.com</span>
              </div> -->
            </div>
          </div>
          <!--    <div class="seller-star">seller-star</div>-->
          <!-- <div class="description">
            <span style="margin-bottom: 0.5rem">{{ shopData.intro }}</span>
            <span>{{ shopData.shopNotice }}</span>
          </div> -->
        </div>
  
        <div v-if="shopData.vouchers?.length" class="voucher-container">
          <h1 class="voucher-title">{{ $t('voucherInfo.ShopVoucherTitle') }}</h1>
          <div class="voucher-card-container">
            <voucher-card v-for="(voucher,index) in shopData.vouchers" :key="index" :voucher="voucher"/>
          </div>
        </div>
      </div>
      <div class="infinite-card-main-container" v-if="isProdLoading">
        <ItemSkeleton v-for="(index) in 12" :key="index"></ItemSkeleton>
      </div>
      <div class="infinite-card-main-container" v-else>
        <item-card
          v-for="(item, index) in displayedRecommendedProducts"
          :key="index"
          class="item-details-card"
          :picture="item.pic"
          :itemName="item.prodName"
          :soldCount="item.soldNum"
          :voucherCount="2"
          :discount="10"
          :price="item.price"
          :priceSymbole="item.priceSymbol"
          :prevPrice="item.oriPrice"
          :productId="item.prodId"
          :transport="item.isDeliveryFree"
          :itemNameEn="item.prodNameEn"
          :isActivePromotion="item.isActivePromotion" :discountPercentage="item.discountPercentage" :promotionTag="item.promotionTag"
          :isOutOfStock="item.isOutOfStock"
        />
      </div>
      <infinite-loading @infinite="getShopProducts" spinner="circles" />
    </div>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
// import MapIcon from "@/assets/icons/svg/map.svg";
// import SmsTracking from "@/assets/icons/svg/sms-tracking.svg";
import Intro from "@/assets/icons/svg/intro.svg";
import Notice from "@/assets/icons/svg/notice.svg";
// import back from "@/assets/icons/svg/drop left.svg";
import { getShopDetails, getProductsInShop } from "@/api/product";
const ItemCard = defineAsyncComponent(() => import("@/components/ItemCard/ItemCard.vue"));
import {useRegionStore} from "@/stores/regionStore"
import InfiniteLoading from "v3-infinite-loading";
import  catchTokenError from "@/utils/catchInvalidTokenError"
import VoucherCard from "../Product/SubComponents/VoucherCard.vue";
import CartItemSkeleton from '@/components/ItemSkeletons/CartItemSkeleton.vue';
import ItemSkeleton from '@/components/ItemSkeletons/ItemSkeleton.vue';
import { useHead } from '@vueuse/head';
const svgIcon = defineAsyncComponent(() =>
  import("@/components/SvgIcon/SvgIcon")
);

export default {
  name: "ProductSellerTab",
  components: { svgIcon, ItemCard,InfiniteLoading,VoucherCard,
    CartItemSkeleton, ItemSkeleton 
  },
  setup() {
    const regionStore = useRegionStore();
    const regionId = regionStore.regionId;
    return {regionId}
  },
  data() {
    return {
      // back: back,
      Intro: Intro,
      Notice: Notice,
      //CallIcon: CallIcon,
      // LinkIcon: LinkIcon,
      shopData: [],
      shopId: null,
      productList: [],
      current : 1,
      isLoading:true,
      isProdLoading:true,
      discription:"",
      title:"",
    };
  },
  computed: {
    displayedRecommendedProducts() {
      return this.productList
    }
  },
  methods: {
    async getShopProducts(){
      try {
        let shopId = this.$route.params.storeId;
        const {data} = await getProductsInShop(shopId,this.regionId,this.current,24);
        this.productList.push(...data.records);
        this.isProdLoading = false
        this.current++
      } catch (error) {
        catchTokenError(error)
        console.log("Error while getting products in the shop : ", error);
      }
    }
  },

  created() {
    let storeId = this.$route.params.storeId;
    getShopDetails(storeId).then((response) => {
      this.shopData = response.data;
      this.isLoading = false
      this.shopId = response.data.shopId
      this.discription = "Discover the latest trends and amazing deals at "+ this.shopData.shopName+ " on iCan Mall. Shop now and enjoy a seamless online shopping experience! ";
      this.title = "Shop Online: "+this.shopData.shopName+" Store at iCan Mall | Free Delivery";
      const URL = window.location.href 
      useHead({
        title:this.title,
        meta:[
          {
            name:`description`,
            content:this.discription
          },
          {
            property: 'og:description',
            content:this.discription
          },
          {
            property: 'og:title',
            content:this.title
          },
          {
            property: 'og:url',
            content: URL,
          },
        ],
        link:[
          {
            rel: 'canonical',
            href: URL
          }
        ]
    })
    }).catch((err) => {
      catchTokenError(err)
    });
  },
};
</script>

<style scoped lang="sass">
@import "@/assets/layout/styles/__variables.sass"

.container
  display: flex
  justify-content: center
  width: 80vw
  margin: auto
  min-height: 62vh
  margin-bottom: 1rem
  @media (max-width: 900px)
    width: 100vw

.tabs
  display: block
  width: 100%

.tab-section
  margin-top: 1rem

.container-seller
  display: grid
  background-color: $dark-color-8
  border-radius: 5px
  @media screen and (min-width : $sm)
    padding: 1.5rem
    grid-template-rows: auto auto
    grid-template-columns: 13rem 8rem 8rem 8rem auto auto
    grid-template-areas: "seller-image-area seller-info-area seller-info-area seller-info-area seller-info-area seller-info-area" "seller-image-area seller-rate-area seller-review-area seller-product-area .visit-store-area"
  @media screen and (max-width : 740px)
    padding: 1rem
    grid-template-rows: auto auto
    grid-template-columns: 13rem 5rem 5rem auto auto auto
    grid-template-areas: "seller-image-area seller-info-area seller-info-area seller-info-area seller-info-area seller-info-area" "seller-image-area seller-rate-area seller-review-area seller-product-area .visit-store-area"
  @media screen and (max-width : $sm)
    padding: 0.5rem
    grid-template-rows: auto auto auto
    grid-template-columns: auto auto auto
    grid-template-areas: "seller-image-area seller-info-area seller-info-area" "seller-rate-area seller-review-area seller-product-area" "visit-store-area visit-store-area visit-store-area"
  .image-section
    grid-area: seller-image-area
    @media screen and (min-width : $sm)
      margin-right: 0
    @media screen and (max-width : $sm)
      margin-right: 0.5rem
      margin-left: 0.7rem
      margin-top: 0.7rem
    img
      @media screen and (min-width : $sm)
        width: 12rem
        height: 12rem
      @media screen and (max-width : $sm)
        width: 6.25rem
        height: 6.25rem
        object-fit: cover
        object-position: center right
  .seller-info
    grid-area: seller-info-area
    .top-section-seller
      display: flex
      justify-content: flex-start
      .seller-name
        white-space: nowrap
        font-weight: 600
        margin-bottom: 1rem
        @media screen and (min-width : $sm)
          max-width: 20rem
          font-size: 1.25rem
        @media screen and (max-width : $sm)
          margin-top: 0.7rem
          max-width: 9.063rem
          font-size: 1rem
      .star-section
        @media screen and (max-width : $sm)
          margin-top: 0.7rem
    .bottom-section-seller
      text-align: left
      .store-title
        font-size: 1.25rem
        font-weight: 600
      .store-address, .store-domain
        margin-top: 1rem
        margin-bottom: 1rem
      .store-address, .store-domain
        display: flex
        flex-direction: row
        font-size: 0.875rem
        font-weight: 400
        color: $dark-color-3
        line-height: 1.1rem
        svg
          padding: 0 0.6rem 0 0
  .seller-rate
    grid-area: seller-rate-area
  .seller-review
    grid-area: seller-review-area
  .seller-product
    grid-area: seller-product-area
  .visit-store
    grid-area: visit-store-area
    display: flex
    @media screen and (max-width: $sm)
      align-items: center
      justify-content: center
      margin-bottom: 0.7rem
    @media screen and (min-width: $sm)
      align-items: flex-end
      justify-content: flex-end
    button
      padding: 0.8rem
      background-color: $main-theme-color
      border: none
      border-radius: 5px
      color: $dark-color-8
      @media screen and (max-width: $sm)
        margin-top: 0.8rem
        width: 60%
      @media screen and (min-width: $sm)
        margin-top: 1.438rem
        width: 100%
  .seller-rate, .seller-review, .seller-product
    display: flex
    flex-direction: column
    @media screen and (max-width : $sm)
      text-align: left
      justify-content: flex-start
      padding-left: 2rem
      margin-top: 2rem
      @media screen and (min-width : $sm)
        text-align: left
        justify-content: flex-end
      span:nth-child(1)
        font-weight: 600
        @media screen and (max-width : $sm)
          font-size: 1.2rem
        @media screen and (min-width : $sm)
          font-size: 2rem
          color: $dark-color-1
      span:nth-child(2)
        @media screen and (max-width : $sm)
          font-size: 0.7rem
        @media screen and (min-width : $sm)
          font-size: 0.875rem
          color: $dark-color-3

.infinite-card-main-container
    padding-top: 1rem
    display: grid
    row-gap: 1rem
    column-gap: 0.5rem
    overflow-y: hidden !important
    justify-content: space-between
    width: 100%
    grid-template-rows: auto
    grid-template-columns: auto auto auto auto auto auto
    @media screen and (min-width: 1700px)
      grid-template-rows: auto
      grid-template-columns: auto auto auto auto auto auto
    @media screen and (max-width: $md)
      width: 100%
      column-gap: 1rem
      justify-content: space-around
      grid-template-rows: auto
      grid-template-columns: auto auto auto auto
    @media screen and (max-width: $sm)
      width: 100%
      row-gap: 0.5rem
      column-gap: 0.5rem
      padding: 1rem 0rem
      grid-template-rows: auto auto
      grid-template-columns: auto auto
.back-arrow
  margin-right: 0.25rem
  margin-bottom: 0.25rem
  cursor: pointer
.description
  white-space: nowrap
  flex-direction: column
  display: flex
  width: 100%
  @media screen and (min-width: $sm)
    display: none
  @media screen and (max-width: $md)
    display: none

.voucher-container
  //background: linear-gradient(90deg, #EF7A00 -1.64%, #FBD702 108.83%)
  margin: 20px 0
  height: auto
  overflow-y: scroll
  -ms-overflow-style: none
  scrollbar-width: none
  background: #ffff
  padding-left: 1rem
.voucher-container::-webkit-scrollbar //Hide scrollbar for Chrome, Safari and Opera
  display: none
.voucher-title
  font-size: 20px
  color: #000
  margin: 20px 0 0 0px

.voucher-card-container
  display: flex
  flex-wrap: wrap
  align-items: left
  justify-content: left
  margin: 20px 0
</style>